var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFrameSlotCard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 227.387,
    height: 312.848,
    viewBox: "0 0 227.387 312.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0.5,
    cy: 0.5,
    r: 0.872,
    gradientTransform: "translate(0 0)",
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#004e6e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("filter", {
    id: "b",
    x: 2.59,
    y: 0,
    width: 222.208,
    height: 312.848,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8,
    result: "c"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0cf",
    floodOpacity: 0.612
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "c"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 2.59,
    y: 0,
    width: 222.208,
    height: 312.848,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.451,
    result: "g"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "g"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 8.297,
    y: 17.077,
    width: 193.319,
    height: 220.642,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0cf"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "j",
    x: 8.297,
    y: 17.077,
    width: 193.319,
    height: 220.642,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.5,
    result: "k"
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "k"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "m",
    x: 25.77,
    y: 56.241,
    width: 193.32,
    height: 220.642,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.5,
    result: "n"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0cf"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "n"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "o",
    x: 25.77,
    y: 56.241,
    width: 193.32,
    height: 220.642,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.5,
    result: "p"
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "q"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "p"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "q"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "r",
    x: 0,
    y: 5.315,
    width: 227.387,
    height: 283.144,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 16.5,
    result: "s"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#0cf"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "s"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "t",
    x: 0,
    y: 5.315,
    width: 227.387,
    height: 283.144,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 49.5,
    result: "u"
  }), /*#__PURE__*/React.createElement("feFlood", {
    result: "v"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "u"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "v"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-583.911 -180.953)",
    opacity: 0.9
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 583.91, 180.95)",
    filter: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1892.11-493.3v237.655l-13.155,13.106h-146.9L1718.9-255.641V-493.3l13.136-13.087h146.936Z",
    transform: "matrix(-1, 0, 0, -1, 1919.2, -218.04)",
    stroke: "rgba(0,204,255,0.61)",
    strokeWidth: 1,
    fill: "url(#a)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1892.11-493.3v237.655l-13.155,13.106h-146.9L1718.9-255.641V-493.3l13.136-13.087h146.936Z",
    transform: "matrix(-1, 0, 0, -1, 2503.11, -37.082)",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 583.91, 180.95)",
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1892.11-493.3v237.655l-13.155,13.106h-146.9L1718.9-255.641V-493.3l13.136-13.087h146.936Z",
    transform: "matrix(-1, 0, 0, -1, 1919.2, -218.04)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1892.11-493.3v237.655l-13.155,13.106h-146.9L1718.9-255.641V-493.3l13.136-13.087h146.936Z",
    transform: "matrix(-1, 0, 0, -1, 2503.11, -37.082)",
    fill: "none",
    stroke: "rgba(0,204,255,0.61)",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.22
  }, /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 583.91, 180.95)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.732,182.568a36.666,36.666,0,0,1,30.241-57.313h.02a7.847,7.847,0,0,0,3.965-1.06,48.377,48.377,0,0,0,15.707-14.682l8.17-12.216L943.4,81.507q-4.457,4.605-9.234,9.265-2.2,2.139-4.378,4.208c-1.724,1.589-4.559,4.172-7.832,7.008a32.662,32.662,0,0,1-4.222,3.186A31,31,0,0,1,914.8,106.8a51.139,51.139,0,0,0-9.825-.864,55.982,55.982,0,0,0-37.788,97.208,30.406,30.406,0,0,0,2.73-3.981,35.975,35.975,0,0,0,3.892-10.84A50.537,50.537,0,0,0,874.732,182.568Z",
    transform: "translate(-791.28 -14.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 583.91, 180.95)",
    filter: "url(#j)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M874.732,182.568a36.666,36.666,0,0,1,30.241-57.313h.02a7.847,7.847,0,0,0,3.965-1.06,48.377,48.377,0,0,0,15.707-14.682l8.17-12.216L943.4,81.507q-4.457,4.605-9.234,9.265-2.2,2.139-4.378,4.208c-1.724,1.589-4.559,4.172-7.832,7.008a32.662,32.662,0,0,1-4.222,3.186A31,31,0,0,1,914.8,106.8a51.139,51.139,0,0,0-9.825-.864,55.982,55.982,0,0,0-37.788,97.208,30.406,30.406,0,0,0,2.73-3.981,35.975,35.975,0,0,0,3.892-10.84A50.537,50.537,0,0,0,874.732,182.568Z",
    transform: "translate(-791.28 -14.93)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 583.91, 180.95)",
    filter: "url(#m)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M935.214,141.251a36.666,36.666,0,0,1-30.241,57.313h-.02a7.846,7.846,0,0,0-3.965,1.06,48.388,48.388,0,0,0-15.707,14.682l-8.17,12.216-10.561,15.79q4.457-4.606,9.234-9.265,2.2-2.139,4.378-4.208c1.724-1.589,4.558-4.172,7.832-7.008a32.618,32.618,0,0,1,4.222-3.186,30.906,30.906,0,0,1,2.932-1.631,51.166,51.166,0,0,0,9.825.864,55.982,55.982,0,0,0,37.788-97.208,30.418,30.418,0,0,0-2.73,3.981,35.971,35.971,0,0,0-3.892,10.84A50.5,50.5,0,0,0,935.214,141.251Z",
    transform: "translate(-791.28 -14.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 583.91, 180.95)",
    filter: "url(#o)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M935.214,141.251a36.666,36.666,0,0,1-30.241,57.313h-.02a7.846,7.846,0,0,0-3.965,1.06,48.388,48.388,0,0,0-15.707,14.682l-8.17,12.216-10.561,15.79q4.457-4.606,9.234-9.265,2.2-2.139,4.378-4.208c1.724-1.589,4.558-4.172,7.832-7.008a32.618,32.618,0,0,1,4.222-3.186,30.906,30.906,0,0,1,2.932-1.631,51.166,51.166,0,0,0,9.825.864,55.982,55.982,0,0,0,37.788-97.208,30.418,30.418,0,0,0-2.73,3.981,35.971,35.971,0,0,0-3.892,10.84A50.5,50.5,0,0,0,935.214,141.251Z",
    transform: "translate(-791.28 -14.93)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 583.91, 180.95)",
    filter: "url(#r)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M949.26,96.26a325.273,325.273,0,0,1-28.49,33.647,66.634,66.634,0,0,1-16.254,12.434,63.526,63.526,0,0,1-9.953,4.3c.063.1.161.257.274.457,1.661,2.948,1.57,6.354.913,9.509-2.087,10.023-9.805,24.884-19.724,42.059-6.722,11.641-12.549,20.971-16.437,27.064-6.5,10.19-12.238,18.7-16.761,25.222l-2.049,2.939c7.4-10.488,15.147-20.157,19.906-26.515a325.306,325.306,0,0,1,28.49-33.647,66.64,66.64,0,0,1,16.254-12.435,63.572,63.572,0,0,1,9.953-4.3c-.062-.1-.161-.257-.274-.457-1.661-2.948-1.57-6.354-.913-9.509,2.087-10.023,9.806-24.884,19.724-42.059,6.722-11.641,12.549-20.971,16.437-27.064,6.5-10.189,12.237-18.7,16.761-25.221l2.05-2.94C961.767,80.233,954.019,89.9,949.26,96.26Z",
    transform: "translate(-791.28 -14.93)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 583.91, 180.95)",
    filter: "url(#t)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M949.26,96.26a325.273,325.273,0,0,1-28.49,33.647,66.634,66.634,0,0,1-16.254,12.434,63.526,63.526,0,0,1-9.953,4.3c.063.1.161.257.274.457,1.661,2.948,1.57,6.354.913,9.509-2.087,10.023-9.805,24.884-19.724,42.059-6.722,11.641-12.549,20.971-16.437,27.064-6.5,10.19-12.238,18.7-16.761,25.222l-2.049,2.939c7.4-10.488,15.147-20.157,19.906-26.515a325.306,325.306,0,0,1,28.49-33.647,66.64,66.64,0,0,1,16.254-12.435,63.572,63.572,0,0,1,9.953-4.3c-.062-.1-.161-.257-.274-.457-1.661-2.948-1.57-6.354-.913-9.509,2.087-10.023,9.806-24.884,19.724-42.059,6.722-11.641,12.549-20.971,16.437-27.064,6.5-10.189,12.237-18.7,16.761-25.221l2.05-2.94C961.767,80.233,954.019,89.9,949.26,96.26Z",
    transform: "translate(-791.28 -14.93)",
    fill: "#fff"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrameSlotCard);
export default __webpack_public_path__ + "static/media/frameSlotCard.cceeaf23be69676b2ed909027f856874.svg";
export { ForwardRef as ReactComponent };